import SubPageHeader from './SubPageHeader'
import type { Props as SubPageHeaderProps } from './SubPageHeader'

const SubPageHeaderComponent = SubPageHeader

export { SubPageHeaderProps }

export default SubPageHeaderComponent
